<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 18:16:14
 * @LastEditors: yd
 * @LastEditTime: 2020-09-10 18:46:43
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\add\index.vue
-->
<template>
  <mrc_ess_myStep v-model="step"
                  :list='stepList'>
    <template v-slot:1>
      <base-info @success='success'
                 :disabled='false'
                 :loading='loading'
                 @cancel='cancel'></base-info>
    </template>
    <template v-slot:2>
      <columnTabs :readonly='false'
                  :baseInfo='params'
                  @success='submit'
                  @lastStep='lastStep'
                  :loading='loading'></columnTabs>
    </template>
  </mrc_ess_myStep>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import baseInfo from '../modules/baseInfo'
import columnTabs from '../modules/columnTabs'
export default {
  components: { baseInfo, columnTabs },
  props: {},
  data () {
    return {
      step: 1,
      params: {},
      loading: false
    };
  },
  validations: {},
  computed: {
    stepList () {
      return [
        { name: this.$t('label_Basic_information') },
        { name: this.$t('数据策略') },
      ]
    }
  },
  created () { },
  watch: {},
  mounted () { },

  methods: {
    success (val) { // 下一步
      this.step = 2
      this.params = val
    },
    cancel () { // 取消
      this.$myConfirm({ content: this.$t('message_Confirm_the_cancellation_of_the_edit') })
        .then(() => {
          this.$router.go(-1)
        }).catch(() => { })
    },
    submit () {  // 提交

    },
    lastStep () {  //上一步
      this.step = 1
    }
  }
}
</script>

<style scoped>
</style>
